import { getAnchorUrlFromEvent } from './getAnchorUrlFromEvent';

const handleUrl = (event, openUrlCallback) => {
    const url = getAnchorUrlFromEvent(event);
    if (!url) return;

    openUrlCallback(url);
    event.stopPropagation();
    event.preventDefault();
};

export default handleUrl;
